import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  NumberOfExistingProperties,
  ProfileStatus,
  PurchaserType,
  Residency,
} from '@/constants/private-resale/bsd';
import { PAGE } from '@/constants/common';
import { FormTypes } from '.';

export const initialState = {
  formField: {
    purchasePrice: '',
    purchaserType: PurchaserType.Individual,
    profileStatus: ProfileStatus.Single,
    profiles: [
      {
        name: 'Profile A',
        residency: Residency.Citizen,
        numberOfExistingProperties: NumberOfExistingProperties.NoProperty,
      },
    ],
  },
  loading: true,
  from: '' as PAGE | '',
};

export const buyerStampDutySlice = createSlice({
  name: 'bsd',
  initialState,
  reducers: {
    updateDataForm: (
      state,
      action: PayloadAction<
        FormTypes & {
          from: PAGE | '';
        }
      >,
    ) => {
      const { from, ...rest } = action.payload;

      state.formField = rest;
      state.from = action.payload.from;
    },
    updateFrom: (state, action: PayloadAction<PAGE>) => {
      state.from = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: () => {},
});

export const { updateDataForm, updateFrom, reset } = buyerStampDutySlice.actions;

export default buyerStampDutySlice.reducer;
